export enum CURRENTY_ENUM {
  USDT = 1,
  INR = 2,
  BRL = 3,
}

export enum CURRENCY_STR {
  USDT = 'USDT',
  INR = 'INR',
  BRL = 'BRL',
}